import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { useRegionPieChart } from '../../hooks/useRegionPieChart';
import { renderPieLabel } from '../../utils/pieChartUtils';
import { PieChartTooltip } from '../ToolTips/PieChartTooltip';
import styles from './RegionPieChart.module.css';

const RegionPieChart: React.FC = () => {
	const { chartData, isLoading, isError } = useRegionPieChart();

	if (isError || isLoading || chartData.every(item => item.value === 0)) {
		return (
			<div className={styles.container} role="status">
				{isError
					? 'Não foi possível carregar os usuários por região.'
					: isLoading
						? 'Carregando usuários por região...'
						: 'Nenhum usuário encontrado nessas regiões.'}
			</div>
		);
	}

	return (
		<div className={styles.container}>
			<ResponsiveContainer width="100%" height="100%">
				<PieChart>
					<Pie
						data={chartData}
						stroke={chartData.length === 1 ? 'none' : '#fff'}
						cx="50%"
						cy="50%"
						labelLine={false}
						label={(props) => renderPieLabel(props, chartData.length === 1)}
						outerRadius="85%"
						dataKey="value"
						animationDuration={800}
						animationBegin={0}
					>
						{chartData.map((item, index) => (
							<Cell key={`cell-${item.name}-${index}`} fill={item.color} />
						))}
					</Pie>
					<Tooltip content={<PieChartTooltip />} />
				</PieChart>
			</ResponsiveContainer>
		</div>
	);
};

export default RegionPieChart;
